<template>
  <div class="container">
    <b-card tag="article" class="mb-2">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-lg-12 col-md-12">
          <h1>Importa Bilancio Consuntivo Teatro Coccia</h1>
          <!-- dropdown stagione -->
          <b-row>
            <b-col xl="12" md="12" class="pt-1">
              <ejs-dropdownlist id="dropStagione" ref="dropStagione"
                                :dataSource="annoRiferimentoList" :index="annoIndex" :fields="annoRiferimentoFields"
                                v-model="annoRiferimentoCorrente"
                                placeholder="Seleziona un Anno"></ejs-dropdownlist>
            </b-col>
            <b-col xl="12" md="12" class="pt-1">
              <ejs-dropdownlist id="meseRiferimento" ref="dropMeseRiferimento"
                                :dataSource="meseRiferimentoList" :index="meseRiferimentoIndex" :fields="meseRiferimentoFields"
                                v-model="meseRiferimentoCorrente"
                                placeholder="Seleziona un Mese"></ejs-dropdownlist>
            </b-col>
          </b-row>
          <b-row>
            <b-col xl="12" md="12" class="pt-1">
              <label for="importaConsuntivo" class="h5">Seleziona file xlsx: </label>
              <ejs-uploader ref="importaConsuntivo" id='importaConsuntivo' name="importaConsuntivo" :asyncSettings="path"
                        :removing="addJWTHeaders" :autoUpload="false" :multiple="multiplo"
                        :uploading="onFileUpload" :success="afterUpload" :failure="uploadError"
              ></ejs-uploader>
            </b-col>
          </b-row>
        </div>
      </div>
      <div class="row">
        <div class="mt-2 col-xs-12 col-sm-12 col-lg-12 col-md-12" v-if="alertErrore">
          <b-alert show dismissible variant="warning">
            <h4 class="alert-heading">Errore</h4>
            <p class="m-2" v-for="m in messaggio">
              {{ m }}
            </p>
          </b-alert>
        </div>
      </div>
    </b-card>
  </div>
</template>
<script>
 import Vue from 'vue'
 import useJwt from '@/auth/jwt/useJwt'
 import {
   LayoutPlugin,
   TabsPlugin,
   CardPlugin,
   DropdownPlugin,
   ImagePlugin,
   LinkPlugin,
   AlertPlugin,
   ToastPlugin,
   SpinnerPlugin,
 } from "bootstrap-vue";
 import { ButtonPlugin } from '@syncfusion/ej2-vue-buttons'
 import { UploaderPlugin } from '@syncfusion/ej2-vue-inputs'
 import { createElement } from '@syncfusion/ej2-base'
 import { DropDownListPlugin } from "@syncfusion/ej2-vue-dropdowns";

 const uploadEle = createElement('span', { className: 'prova' })
 uploadEle.innerHTML = ' '
 const clearEle = createElement('span', { className: 'remove e-icons' })
 clearEle.innerHTML = 'Clear All'

 const axios = require("axios");
 // use bootstrap-vue
 Vue.use(TabsPlugin);
 Vue.use(CardPlugin);
 Vue.use(LayoutPlugin);
 Vue.use(DropdownPlugin);
 Vue.use(ImagePlugin);
 Vue.use(LinkPlugin);
 Vue.use(AlertPlugin);
 Vue.use(ToastPlugin);
 Vue.use(SpinnerPlugin);
 Vue.use(ButtonPlugin)
 Vue.use(UploaderPlugin)
 Vue.use(DropDownListPlugin);

 export default {
   data() {
     return {
       d: [],
       annoRiferimentoCorrente: null,
       annoRiferimentoList: [
         { label: "Anno 2022", val: "2022" },
         { label: "Anno 2023", val: "2023" },
         { label: "Anno 2024", val: "2024" },
         { label: "Anno 2025", val: "2025" },
         { label: "Anno 2026", val: "2026" },
         { label: "Anno 2027", val: "2027" },
       ],
       annoRiferimentoFields: { value: "val", text: "label" },
       annoIndex: -1,
       meseRiferimentoList: [
         { label: "Gennaio", val: "01" },
         { label: "Febbraio", val: "02" },
         { label: "Marzo", val: "03" },
         { label: "Aprile", val: "04" },
         { label: "Maggio", val: "05" },
         { label: "Giugno", val: "06" },
         { label: "Luglio", val: "07" },
         { label: "Agosto", val: "08" },
         { label: "Settembre", val: "09" },
         { label: "Ottobre", val: "10" },
         { label: "Novembre", val: "11" },
         { label: "Dicembre", val: "12" },
       ],
       meseRiferimentoFields: { value: "val", text: "label" },
       meseRiferimentoIndex: -1,
       meseRiferimentoCorrente: null,
       
       showDownload: false,
       multiplo: false,
       messaggio: [],
       fileMinisteroUrl: "",
       fileConsulenteLavoroUrl: "",
       alertErrore: false,
       path: {
         saveUrl: `${process.env.VUE_APP_API_ENDPOINT}/demo/api/bilanciococciaconsuntivo/importa`,
       },
       buttons: {
         browse: 'Scegli file',
         clear: clearEle,
         upload: uploadEle,
       },
     }
   },
   methods: {
     // per toast
     makeToast(variant = null, title = 'titolo', message = 'messaggio') {
       this.$bvToast.toast(message, {
         title,
         variant,
         solid: true,
         autoHideDelay: 10000,
       })
     },
     addJWTHeaders(args) {
       const token = useJwt.getToken()

       useJwt.check() // qui dovrei restituire una promise per poter aspettare che venga risolta?
       args.currentRequest.setRequestHeader('Authorization', 'Bearer ' + token)
     },
     onFileUpload(args) {
       console.log("FILEDATA")
       console.log(args.fileData)

       const token = useJwt.getToken()

       useJwt.check() // qui dovrei restituire una promise per poter aspettare che venga risolta?
       args.currentRequest.setRequestHeader('Authorization', 'Bearer ' + token)
     },
     afterUpload(args) {
       // console.log(args)
       if (args.name === 'success') {
         console.log('tutto a posto')
         this.makeToast('primary', 'Info', 'Import eseguito correttamente')
         // SEGNA TUTTO OK PER ABILITARE DOWNLOAD
       }
     },
     uploadError(args) {
       //console.log(args)
       let response = JSON.parse(args.e.target.response)
       // console.log(response)
       if (response) {
         response.forEach((k) => {
           if ('errore' in k) {
             this.messaggio.push(k.errore)
           } else {
             for (const [key, value] of Object.entries(k)) {
               this.messaggio.push(`${key}: ${value}`);
             }
           }
           this.alertErrore = true
         })
         // this.makeToast("primary", "ERRORE", messaggio);
       }
       // TODO: gestione errore con download report
     },
   },
 }
</script>
<style>
  @import "~@syncfusion/ej2-base/styles/bootstrap.css";
  @import "~@syncfusion/ej2-buttons/styles/bootstrap.css";
  @import "~@syncfusion/ej2-vue-inputs/styles/bootstrap.css";
  @import "~@syncfusion/ej2-dropdowns/styles/bootstrap.css";
  
  .control-section {
    height: 100%;
    min-height: 200px;
  }

  button:has(> span.prova)
  {
    display: none;
  }
</style>
